module.exports = __webpack_public_path__ + "static/media/clone.ce15c962.svg";